import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './lib/i18n/config';
import App from './App';
import './index.css';
import { errorTracker } from './lib/analytics/errorTracking';
import reportWebVitals from './lib/analytics/webVitals';

// Initialize error tracking
errorTracker;

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Report web vitals
reportWebVitals();